import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'

// Screens
import CareerScreen from './screens/CareersScreen';
import ContactUsScreen from './screens/ContactUsScreen';
import AboutScreen from './screens/AboutScreen';
import CapabilitiesScreen from './screens/CapabilitiesScreen';
import ValveDesignPage from './screens/capabilities/ValveDesignPage';
import MachiningPage from './screens/capabilities/MachiningPage';
import CleaningPage from './screens/capabilities/CleaningPage';
import AssemblyTestPage from './screens/capabilities/AssemblyTestPage';
import EnvironmentalTestingPage from './screens/capabilities/EnvironmentalTestingPage';
import ContractManufacturingPage from './screens/capabilities/ContractManufacturingPage';
import ApplicationsScreen from './screens/ApplicationsScreen';
import AerospaceValvesPage from './screens/AerospaceValvesPage';
import FacilityV2Screen from './screens/FacilityV2Screen';
import CertificationsScreen from './screens/CertificationsScreen';
import OurStoryV1Screen from './screens/OurStoryV1Screen';
import OurStoryV2Screen from './screens/OurStoryV2Screen';
import TimelineAdminScreen from './screens/TimelineAdminScreen';
import ProductsAdminScreen from './screens/ProductsAdminScreen';
import NewsScreen from './screens/NewsScreen';
import NewsScreenV2 from './screens/NewsScreenV2';
import NewsArticleScreen from './screens/NewsArticleScreen';
import NewsAdminScreen from './screens/NewsAdminScreen';
import CertificationsAdminScreen from './screens/CertificationsAdminScreen';
import CapabilitiesAdminScreen from './screens/CapabilitiesAdminScreen';
import PageNotFound from './screens/PageNotFound';
import AdminScreen from './screens/AdminScreen';
import CompanyStatsAdminScreen from './screens/CompanyStatsAdminScreen';

import SearchResultsScreen from './screens/SearchResultsScreen';

// Product pages (new mockup-based design)
import ProductsLandingPage from './screens/products/ProductsLandingPage';
import ProductCategoryPage from './screens/products/ProductCategoryPage';
import ProductDetailPage from './screens/products/ProductDetailPage';
import CustomProductsPage from './screens/products/CustomProductsPage';

// Main page
import PageV2 from './versions/v2/PageV2';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Routes>
        {/* Main site */}
        <Route path='/' element={<PageV2 />} />

        {/* Sub-pages */}
        <Route path='/careers' element={<CareerScreen />} />
        <Route path='/contactus' element={<ContactUsScreen />} />
        <Route path='/about' element={<AboutScreen />} />
        <Route path='/facility' element={<FacilityV2Screen />} />
        <Route path='/certifications' element={<CertificationsScreen />} />
        <Route path='/quality' element={<CertificationsScreen />} />
        <Route path='/capabilities' element={<CapabilitiesScreen />} />
        <Route path='/capabilities/valve-design' element={<ValveDesignPage />} />
        <Route path='/capabilities/machining' element={<MachiningPage />} />
        <Route path='/capabilities/cleaning' element={<CleaningPage />} />
        <Route path='/capabilities/assembly-test' element={<AssemblyTestPage />} />
        <Route path='/capabilities/environmental-testing' element={<EnvironmentalTestingPage />} />
        <Route path='/capabilities/contract-manufacturing' element={<ContractManufacturingPage />} />
        <Route path='/applications' element={<ApplicationsScreen />} />
        <Route path='/aerospace-valves' element={<AerospaceValvesPage />} />
        <Route path='/story' element={<AboutScreen />} />
        <Route path='/story/v1' element={<OurStoryV1Screen />} />
        <Route path='/story/v2' element={<OurStoryV2Screen />} />
        <Route path='/story/admin' element={<TimelineAdminScreen />} />
        <Route path='/admin' element={<AdminScreen />} />
        <Route path='/admin/stats' element={<CompanyStatsAdminScreen />} />
        <Route path='/search' element={<SearchResultsScreen />} />

        {/* Products - new mockup-based pages */}
        <Route path='/products' element={<ProductsLandingPage />} />
        <Route path='/products/category/:categoryId' element={<ProductCategoryPage />} />
        <Route path='/products/custom' element={<CustomProductsPage />} />
        <Route path='/products/admin' element={<ProductsAdminScreen />} />
        <Route path='/products/:id' element={<ProductDetailPage />} />

        {/* News */}
        <Route path='/news' element={<NewsScreen />} />
        <Route path='/news/v2' element={<NewsScreenV2 />} />
        <Route path='/news/admin' element={<NewsAdminScreen />} />
        <Route path='/certifications/admin' element={<CertificationsAdminScreen />} />
        <Route path='/capabilities/admin' element={<CapabilitiesAdminScreen />} />
        <Route path='/news/:id' element={<NewsArticleScreen />} />
        {/* <Route path='/resources' element={<ResourcesScreen />} /> */}
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
